export enum StatiSegnalazione {
    IN_BOZZA = 'BOZ',
    COMPLETATA = 'COM',
    INVIATA = 'INV',
    RICEVUTA = 'RIC',
    NON_RICEVUTA = 'NOR',
    CONFERMATA = 'CON',
    RIFIUTATA = 'RIF',
    INVIATA_AL_DIPARTIMENTO = "IDI",
    EMERGENZA_NON_RICONOSCIUTA = 'ENR',
    INVIATA_A_DGPE = "IDG",
    IN_BOZZA_PE = 'BPE',
    APERTA_PE = 'APP',
    INVIATA_PE = 'INP',
    CHIUSA_PE = "CHI",
    RICEVUTA_PE = 'RIP',
    COMPLETATA_PE = 'COP',
    CONFERMATA_PE = "CNP",
    RIFIUTATA_PE = 'RFP',
    INVIATA_AL_DIPARTIMENTO_PE = "IPE",
    INVIATA_A_DGPE_PE = "IDP",
    RICHIESTA_INTEGRAZIONE = 'INT',
    RICHIESTA_INTEGRAZIONE_PE = 'ITP'
  }
